import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loading, StatusBadge } from "@/components/common";
import { CustStatusBadge, KindBadge } from "@/components/badges";
import { api, errMsg } from "@/lib/api";
import { fmtDate, fmtDateTime, invNo, num, periodLabel, rupiah } from "@/lib/format";

const Section = ({ title, children }) => (
  <div className="space-y-1 min-w-0"><h3 className="font-display font-semibold text-sm">{title}</h3><div className="xl-wrap max-h-[30vh] max-w-full">{children}</div></div>
);

function Body({ h }) {
  return (
    <div className="space-y-4">
      <Section title="Riwayat Status">
        <table className="xl"><thead><tr><th>Tanggal efektif</th><th>Status</th><th>Catatan</th><th>Oleh</th></tr></thead>
          <tbody>{h.status_history.length === 0 && <tr><td colSpan={4} className="text-slate-500">Status awal: AKTIF</td></tr>}
            {h.status_history.map((s, i) => <tr key={i}><td>{fmtDate(s.effective_date)}</td><td><CustStatusBadge status={s.status} /></td><td className="text-xs">{s.note}</td><td className="text-xs">{s.by} · {fmtDateTime(s.ts)}</td></tr>)}</tbody></table>
      </Section>
      <Section title="Penjualan Aktual & Hutang per Periode">
        <table className="xl"><thead><tr><th>Periode</th><th className="text-right">Qty Terjual</th><th className="text-right">Nilai</th><th className="text-right">Dibayar</th><th className="text-right">Sisa Hutang</th></tr></thead>
          <tbody>{h.periods.map((x) => <tr key={x.period}><td>{periodLabel(x.period)}</td><td className="num">{num(x.qty)}</td><td className="num">{num(x.value)}</td><td className="num">{num(x.debt?.paid)}</td><td className="num text-rose-700">{num(Math.max(x.debt?.remaining || 0, 0))}</td></tr>)}</tbody></table>
      </Section>
      <Section title="Pasokan Awal">
        <table className="xl"><thead><tr><th>Periode</th><th>Ref</th><th>Jenis</th><th className="text-right">Qty</th><th className="text-right">Nilai</th></tr></thead>
          <tbody>{h.supplies.map((s) => <tr key={s.id}><td>{periodLabel(s.period)}</td><td className="font-mono text-xs">{s.ref}</td><td><CustStatusBadge status={s.kind} /></td><td className="num">{num(s.total_qty)}</td><td className="num">{num(s.total_value)}</td></tr>)}</tbody></table>
      </Section>
      <Section title="Invoice">
        <table className="xl"><thead><tr><th>Nomor</th><th>Periode</th><th>Sumber</th><th>Status</th><th className="text-right">Qty</th><th className="text-right">Total</th></tr></thead>
          <tbody>{h.invoices.map((i) => <tr key={i.id}><td className="font-mono text-xs">{invNo(i)}</td><td>{periodLabel(i.period)}</td><td><KindBadge kind={i.supply_source} /></td><td><StatusBadge status={i.status} /></td><td className="num">{num(i.total_qty)}</td><td className="num">{rupiah(i.total)}</td></tr>)}</tbody></table>
      </Section>
    </div>
  );
}

export function CustomerHistoryDialog({ customer, onClose }) {
  const [h, setH] = useState(null);
  useEffect(() => {
    if (!customer) return;
    setH(null);
    api.get(`/customers/${customer.id}/history`).then((r) => setH(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [customer]);
  if (!customer) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto grid-cols-[minmax(0,1fr)]" data-testid="customer-history-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2 flex-wrap pr-8">Riwayat Pelanggan · {customer.name} {h && <CustStatusBadge status={h.status} />}</DialogTitle></DialogHeader>
        {!h ? <Loading /> : <Body h={h} />}
      </DialogContent>
    </Dialog>
  );
}
